module.exports = __webpack_public_path__ + "img/36.0beb1240.jpg";